var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade-transition"}},[(_vm.$vuetify.breakpoint.mobile)?[_c('app-menu-button')]:[_c('div',{staticClass:"app-menu"},[_c('app-nav-menu',{attrs:{"items":_vm.items,"horizontal":""}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }